<div class="header">
  <h1>Bienvenue dans le cours d'angular</h1>
  
</div>
<div class="nav">
  <app-nav></app-nav>
</div>
<div class="content">
  <router-outlet></router-outlet>
</div>